import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * ヘルプダイアログ
 * バージョン、ショートカットの表示
 */
class HelpDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'helpDialog';

    // タイトル
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'ヘルプ'; break;
      default: title = 'Help'; break;
    }

    let contents = '';

    contents += '<div class="p-webcadControlDescriptionBox helpDialog_contentBox">';
    contents += '<div class="subttl"><span class="jp">バージョン番号</span><span class="en">Version</span></div>';
    contents += `<div class="versionInfoBox">${marietta.webcad.WebCADGlobal.APP_NAME} ver.${marietta.webcad.WebCADGlobal.APP_VERSION}</span></div>`;
    contents += `<div class="versionInfoBox">CADAPI（計算API） ver.${marietta.webcad.WebCADGlobal.API_VERSION}</span></div>`;
    contents += '</div>';
    // if(marietta.webcad.WebCADGlobal.userAgentManager.isPC){
    contents += '<div class="p-webcadControlDescriptionBox helpDialog_contentBox">';
    contents += '<div class="subttl"><span class="jp">ショートカット</span><span class="en">Shortcuts</span></div>';
    contents += '<table>';
    contents += '<tbody>';
    contents += '<tr>';
    contents += '<th><span class="jp">ステージの移動</span><span class="en">Move Canvas</span></th>';
    contents += '<td><span class="jp">Space + ドラッグ</span><span class="en">Space + Drag</span></td>';
    contents += '<th><span class="jp">アイテム配置の中断</span><span class="en">Cancel Item Input</span></th>';
    contents += '<td>Esc</td>';
    contents += '</tr>';
    contents += '<tr>';
    contents += '<th><span class="jp">移動（1px）</span><span class="en">Move(1px)</span></th>';
    contents += '<td><span class="jp">矢印キー</span><span class="en">Arrow keys</span></td>';
    contents += '<th><span class="jp">選択中のアイテムを削除</span><span class="en">Delete Selected Item</span></th>';
    contents += '<td>Delete / Backspace</td>';
    contents += '</tr>';
    contents += '<tr>';
    contents += '<th><span class="jp">アイテムのコピー</span><span class="en">Copy Item</span></th>';
    contents += '<td>Ctrl + c</td>';
    contents += '<th><span class="jp">アイテムのペースト</span><span class="en">Paste Item</span></th>';
    contents += '<td>Ctrl + v</td>';
    contents += '</tr>';
    contents += '<tr>';
    contents += '<th><span class="jp">元に戻す</span><span class="en">Undo Item</span></th>';
    contents += '<td>Ctrl + z</td>';
    contents += '<th><span class="jp">やり直す</span><span class="en">Redo Item</span></th>';
    contents += '<td>Ctrl + y</td>';
    contents += '</tr>';
    contents += '<tr>';
    contents += '<th><span class="jp">重なりアイテム表示</span><span class="en">Overlap Item</span></th>';

    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      contents += '<td><span class="jp">アイテム長押し（0.5秒）</span><span class="en">Long press(0.5 seconds)</span></td>';
    }else {
      contents += '<td><span class="jp">右クリック</span><span class="en">Right Click</span></td>';
    }
    contents += '<th><span class="jp"></span><span class="en"></span></th>';
    contents += '<td></td>';
    contents += '</tr>';
    contents += '</tbody>';
    contents += '</table>';
    contents += '</div>';
    // }
    contents += '</div>';

    // footer = '<button id="btnOK"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    const footer = '';

    this.createDialog(id, title, contents, footer);
  }
}

export default HelpDialog;
